//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.Resale

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The ticket metadata model, which contains additional information about the ticket
* 
* @param canCancel Boolean indicating whether the current user can delete a resale
* @param canCreate Boolean indicating whether the current user can create a resale
* @param `data` 
* @param directResaleToken The direct resale token for private resales
*/
@Serializable

data class AccountResale (


      /* Boolean indicating whether the current user can delete a resale */
    @SerialName(value = "canCancel") @Required val canCancel: kotlin.Boolean,


      /* Boolean indicating whether the current user can create a resale */
    @SerialName(value = "canCreate") @Required val canCreate: kotlin.Boolean,


      @SerialName(value = "data") val `data`: Resale? = null,


      /* The direct resale token for private resales */
    @SerialName(value = "directResaleToken") val directResaleToken: kotlin.String? = null


) {




  }

